import { defineMessages } from 'react-intl';

export const costEstimationItemsGroupedTablesMessageDefinitions = defineMessages({
  costUnit: {
    id: 'estimationDetail.costEstimationItemsGrouped.costUnit',
    defaultMessage: 'Cost Unit',
  },
});
